import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import { CustomCard } from "../../../components/Card/CustomCard";

import { DisModSemI, DisModSemII, DisModSemIII, DisModSemIV, DisModSemV, DisModSemVI, DisModElec } from "../../../shared/PensumItems";

class Pensum extends Component {

    materias = (mate) => {
        return (
            mate.map(option => (
                <li key={option.id} className="fuente-monserrat" style={{padding:5}}> 
                    <i class="fa fa-circle" style={{color:"#1f2f6e", fontSize:8}}/> {option.nombre}
                </li>
            ))  
        )
    }

    render() { 
        return (
            <div style = {{backgroundColor:"fafafa"}}>
                <Row>
                    <Col md={12} align="center">
                        <h2 className="fuente-monserrat" style={{color:"#619C9B"}}>PLAN DE ESTUDIO</h2>
                    </Col>
                </Row>
                <Row className="padding-card">
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">I SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(DisModSemI)}</ul>}
                        />
                    </Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">II SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(DisModSemII)}</ul>}
                        />
                    </Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">III SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(DisModSemIII)}</ul>}
                        />
                    </Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">IV SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(DisModSemIV)}</ul>}
                        />
                    </Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">V SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(DisModSemV)}</ul>}
                        />
                    </Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">VI SEMESTRE</div>}
                            color="#a80012"
                            content={<ul>{this.materias(DisModSemVI)}</ul>}
                        />
                    </Col>
                    <Col md={4}></Col>
                    <Col md={4}>
                        <CustomCard
                            height = {340}
                            title={<div className="fuente-monserrat">ELECTIVAS</div>}
                            color="#a80012"
                            content={<ul>{this.materias(DisModElec)}</ul>}
                        />
                    </Col>
                    <Col md={4}></Col>
                </Row>
            </div>
        );
    }
}
 
export default Pensum;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoModa/Pensum.jsx